(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/pix-wager.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/pix-wager.js');
(function(Backbone, _, svs) {
  'use strict';


  svs.maltipset = svs.maltipset || {};
  svs.maltipset.models = svs.maltipset.models || {};

  svs.maltipset.models.PixWager = Backbone.Model.extend({
    defaults: function() {
      return {
        wager: {
          crc: 0,
          marketInfo: 0,
          bagType: 0,
          bets: [
            {
              productId: 'MAL',
              drawNum: 0, 
              numDraws: 1, 
              betAmountSalesGroup1: '0,00', 
              betAmountSalesGroup2: '0,00',
              rowPriceMulti: 1,
              betProperties: [],
              numberBoards: [
                {
                  systemType: [
                    'MSYS'
                  ],
                  systemNum: 0,
                  participation: '0',
                  rowPriceMulti: 1,
                  boardData: [],
                  boardProps: [
                    'QUICKPICK'
                  ]
                }
              ]
            }
          ]
        }
      };
    }
  });
})(Backbone, _, svs);


 })(window);